import { Koi } from '@ksyos/koi';
import type { TypedReadSchema } from '@common/formEngine/typedReadSchema.types';
import type { ProcessActivityAsset } from '@common/validation/processActivityAsset';
import type { TypedSchema } from '@common/validation/utils/typedSchemaType';
import { DietAndPsychAdvice } from '@common/customControls/bariatrics';
import { getProcessActivityAssetsSchema } from '@common/validation/processActivityAsset';
import { addAllowNull } from '@common/validation/utils/addAllowNull';
import { getTextAreaStringSchema } from '@common/validation/utils/getTextAreaStringSchema';

export type BariPreDietScreeningData = {
    advies: DietAndPsychAdvice | null;
    assets: ProcessActivityAsset[];
    toelichting: string | null;
    verslag: string | null;
};

export type BariPreDietScreeningReadKey = keyof BariPreDietScreeningData;
export type BariPreDietScreeningReadLabel =
    | 'Advies inclusie in zorgpad'
    | 'Bestand(en)'
    | 'Toelichting'
    | 'Verslag consult';
export type BariPreDietScreeningSectionTitle = 'Conclusie';

export const bariPreDietScreeningReadSchema: TypedReadSchema<
    BariPreDietScreeningReadKey,
    BariPreDietScreeningReadLabel,
    BariPreDietScreeningSectionTitle
>[] = [
    {
        items: [{ key: 'verslag', label: 'Verslag consult' }],
    },
    {
        items: [
            {
                key: 'assets',
                label: 'Bestand(en)',
            },
        ],
    },
    {
        items: [
            { key: 'advies', label: 'Advies inclusie in zorgpad' },
            { key: 'toelichting', label: 'Toelichting' },
        ],
        sectionTitle: 'Conclusie',
    },
];

const bariPreDietScreeningFinal: TypedSchema<BariPreDietScreeningData> = {
    advies: Koi.string().valid(...Object.values(DietAndPsychAdvice)),
    assets: getProcessActivityAssetsSchema(),
    toelichting: getTextAreaStringSchema(),
    verslag: getTextAreaStringSchema(),
};

const bariPreDietScreeningDraft = addAllowNull(bariPreDietScreeningFinal, ['assets']);

export const bariPreDietScreeningDraftSchema = Koi.object(bariPreDietScreeningDraft);
export const bariPreDietScreeningFinalSchema = Koi.object(bariPreDietScreeningFinal);
